import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import styles from './richtext.module.scss';
import RichtextModel from '../../../models/richtext';
import JsonToString from '../../../helpers/json-to-string';

type Props = {
  data: RichtextModel;
  customClasses?: {
    container?: string;
    bold?: string;
    italic?: string;
    underline?: string;
    link?: string;
    list?: string;
    listItem?: string;
    paragraph?: string;
    orderedList?: string;
    header?: string;
    header2?: string;
    hr?: string;
    table?: string;
    tableRow?: string;
    tableHeaderCell?: string;
    tableCell?: string;
  };
};

interface CProps {
  primary?: string;
  secondary?: string;
}

const CustomStyles = styled.div`
  i > b,
  b > i {
    color: ${(p: CProps) => p.secondary};
  }

  * {
    color: ${(p: CProps) => p.primary};
  }
`;

const Richtext = ({ data, customClasses = {} }: Props) => (
  <div
    className={cx(
      styles.richtext,
      customClasses.container,
      { [styles['richtext__message-component']]: data?.useAsMessageComponent },
      { [styles['richtext--padding']]: data?.addPaddings }
    )}
  >
    <CustomStyles
      primary={data?.color?.primary}
      secondary={data?.color?.secondary}
    >
      <div className={styles.richtext__container}>
        {data?.text?.json &&
          JsonToString(
            data.text,
            {
              bold: styles.richtext__bold,
              italic: styles.richtext__italic,
              underline: styles.richtext__underline,
              link: styles.richtext__link,
              list: styles.richtext__bullet,
              listItem: styles['richtext__list-item'],
              paragraph: styles.richtext__paragraph,
              orderedList: styles.richtext__list,
              header: styles.richtext__header,
              header2: styles.richtext__header2,
              table: styles.richtext__table,
              tableRow: styles['richtext__table-row'],
              tableHeaderCell: styles['richtext__table-header-cell'],
              tableCell: styles['richtext__table-cell'],
              ...customClasses
            },
            {
              fontSize: data.fontSize
            },
            data.analyticsAttributes
          )}
      </div>
    </CustomStyles>
  </div>
);

export default Richtext;
